import { render, staticRenderFns } from "./PasswordResetReception.vue?vue&type=template&id=307f6b34&scoped=true&"
import script from "./PasswordResetReception.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetReception.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetReception.vue?vue&type=style&index=0&id=307f6b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307f6b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VImg,VRow,VTextField})
